module.exports = __webpack_public_path__ + "42a0992558f08b251e7557b35e0c2b45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/31_ICON_10_B.png
// module id = 131
// module chunks = 0